module.exports = __webpack_public_path__ + "img/stock2.71f938f7.png";